import React from 'react';
import { MenuItem, Box, Button, Menu } from '@material-ui/core';
import {
    US as USFlagIcon,
    MX as MXFlagIcon,
    CA as CAFlagIcon,
    BR as BRFlagIcon,
    EE as EEFlagIcon,
} from 'country-flag-icons/react/3x2';
import { makeStyles } from '@material-ui/styles';

export enum ECountryCode {
    Mexico = 'MX',
    USA = 'US',
    Canada = 'CA',
    Brazil = 'BR',
    Estonia = 'EE',
}

export const AREA_CODES: Record<
    ECountryCode,
    {
        countryCode: ECountryCode;
        country: string;
        icon: React.ReactNode;
        code: string;
        format: string;
    }
> = {
    [ECountryCode.Mexico]: {
        countryCode: ECountryCode.Mexico,
        country: 'Mexico',
        icon: <MXFlagIcon style={{ width: 20 }} />,
        code: '+52',
        format: '(+52) ## #### ####',
    },
    [ECountryCode.USA]: {
        countryCode: ECountryCode.USA,
        country: 'USA',
        icon: <USFlagIcon style={{ width: 20 }} />,
        code: '+1',
        format: '(+1) (###) ###-####',
    },
    [ECountryCode.Canada]: {
        countryCode: ECountryCode.Canada,
        country: 'Canada',
        icon: <CAFlagIcon style={{ width: 20 }} />,
        code: '+1',
        format: '(+1) (###) ###-####',
    },
    [ECountryCode.Brazil]: {
        countryCode: ECountryCode.Brazil,
        country: 'Brazil',
        icon: <BRFlagIcon style={{ width: 20 }} />,
        code: '+55',
        format: '(+55) ## #### ####',
    },
    [ECountryCode.Estonia]: {
        countryCode: ECountryCode.Estonia,
        country: 'Estonia',
        icon: <EEFlagIcon style={{ width: 20 }} />,
        code: '+372',
        format: '(+372) #### ####',
    },
};

type IAreaCodeField = {
    countryCode: ECountryCode;
    setCountryCode: (countryCode: ECountryCode) => void;
};

const useStyles = makeStyles(() => ({
    button: {
        minWidth: 20,
        marginRight: 3,
    },
}));

export const AreaCodeField: React.FC<IAreaCodeField> = ({
    countryCode,
    setCountryCode,
}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const classes = useStyles();

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <>
            <Button onClick={handleClick} className={classes.button}>
                {AREA_CODES[countryCode].icon}
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {Object.values(AREA_CODES).map((area) => {
                    return (
                        <MenuItem
                            key={`${area.code}-${area.country}`}
                            value={area.code}
                            onClick={() => {
                                setCountryCode(area.countryCode);
                                handleClose();
                            }}
                        >
                            <Box display="flex" alignItems="center">
                                {area.icon}
                            </Box>
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};
